import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { AppConfig } from "../../../../configs/app";
import { ReservationService } from "../../../../services/reservation.service";
import { CartService } from "../../../../services/cart.service";
import { UserService } from "../../../../services/user.service";
import { CommonService } from "../../../../services/common.service";
import { EmbedCodeService } from "../../../../services/embed-code.service";
import { AffiliateService } from "../../../../services/affiliate.service";
import { PlanService } from "../../../../services/plan.service";
import { AnalyticsService } from "../../../../services/analytics.service";

@Component({
  selector: "page-reserve-finish-index",
  templateUrl: "./index.component.html",
})
export class PageReserveFinishIndexComponent implements OnInit {
  public moment: any;
  public _: any;
  public $: any;

  public reservationData: any;
  public finishData: any;
  public paymentData: any = {};
  public cartQuantity: any = 0; /* FOR SHOWING ONLY */
  /* APIから完了データを取得できない場合に使う、サーバ埋め込みの予約成立データ
     (index.htmlの#acceptServerData。JS不起動対策フォールバックの第2層) */
  public serverFallback: any = null;

  /* EMBED CODES (TRACKING, WIDGETS, ...) */
  public embedCodeHeader: any = "";

  constructor(
    public appConfig: AppConfig,
    public activatedRoute: ActivatedRoute,
    public reservationService: ReservationService,
    public cartService: CartService,
    public userService: UserService,
    public commonService: CommonService,
    public embedCodeService: EmbedCodeService,
    private affiliateService: AffiliateService,
    private planService: PlanService,
    private analyticsService: AnalyticsService
  ) {
    this.$ = this.commonService.getJQuery();
    this.moment = this.commonService.getMoment();
    this._ = this.commonService.getLodash();
  }

  async ngOnInit() {
    this.commonService.showPageLoader("しばらくお待ちください。");

    this.reservationData = this.reservationService.getReservationData();
    this.finishData = this.reservationService.getReservationCompleteData();

    /* GET RIDIRECT PAYPAY FINISH DATA */
    let session_id = this.activatedRoute.snapshot.queryParams.s_id;
    if (session_id && this._.isEmpty(this.finishData)) {
      let returnData = await this.reservationService.getRedirectBooking(
        session_id
      );
      this.finishData = returnData;
    }

    if (this._.isEmpty(this.finishData)) {
      /* APIから完了データを取得できなかった場合、サーバがindex.htmlに埋め込んだ
         予約成立データがあれば最低限の成立表示を行う(従来はここで無言のまま
         プラン一覧へ遷移し、お客様が成立に気づけず再予約・二重決済に至っていた。
         Asana 1217151681259378)。埋め込みも無ければ従来どおりプラン一覧へ
         (無効なs_id・botアクセス等) */
      this.serverFallback = this.getServerFallbackData(session_id);
      if (!this.serverFallback) {
        return this.commonService.redirectToRoute(
          this.commonService.routePaths.pagePlanList
        );
      }
      this.analyticsService.purchaseFallback(this.serverFallback);
      this.commonService.hidePageLoader();
      return;
    }

    //GET PAYMENT CALCULATION DATA
    this.paymentData = this.reservationService.getPaymentCalcData();

    /* 入金期限はサーバ確定値（予約API応答 payment_date = reservation_slips.price_limit_date 由来）を優先。
       localStorage の paymentCalculationData は完了画面への到達経路によっては存在せず
       「月日（）22:00まで」と空欄表示になるため、フォールバック扱いに変更 */
    let serverPaymentDate =
      this.finishData && this.finishData.data
        ? this.finishData.data.payment_date
        : null;
    if (serverPaymentDate) {
      let serverLimit = this.moment(serverPaymentDate, "YYYY/MM/DD HH:mm");
      if (serverLimit.isValid()) {
        this.paymentData = {
          date: serverLimit.format("YYYY-MM-DD"),
          weekDay: this.commonService.getDayLabel(serverLimit.day()),
        };
      }
    }

    this.analyticsService.purchase(this.finishData);

    /* INIT EMBED CODES */
    this.initEmbedCodes();

    /* CLEAR CACHES */
    this.reservationService.removeReservationData();
    this.cartQuantity = 0;

    /* HIDE PAGE LOADER */
    this.commonService.hidePageLoader();

    /* SET GoogleGTM TAG */
    this.$('#embedGoogleGTM').empty().append(this.setGoogleGTM());
  }

  initEmbedCodes() {
    try {
      let reservationPostData = this.reservationService.getReservationData();
      let cartData = this.cartService.getCartData();

      /* CALCULATE PASSENGER */
      let passenger = {
        men: 0,
        women: 0,
        children: 0,
        total: 0,
      };
      for (let item of cartData) {
        passenger.men += item.passenger.adult.men + item.passenger.children.men;
        passenger.women +=
          item.passenger.adult.women + item.passenger.children.women;
        passenger.children += item.passenger.children.total;
        passenger.total +=
          item.passenger.adult.total + item.passenger.children.total;
      }

      let trackingInfo = {
        price: this.finishData.data.total_price,
        reservationID: this.finishData.data.reservation_list[0].reservation_id,
        departureDate: this.moment(
          this.finishData.data.reservation_list[0].dpt_ymd
        ).format("YYYYMMDD"),
        men: passenger.men,
        women: passenger.women,
        totalPeople: passenger.total,
        age: this.moment().diff(reservationPostData.c_birthday, "years"),
        planCode: cartData[0].plan.plan_code,
        planName: encodeURIComponent(cartData[0].plan.course_name),
        children: passenger.children,
        infant: 0,
        paymentMethod: encodeURIComponent(
          reservationPostData.payment_method ==
            this.appConfig.reservation.paymentType.creditCard
            ? "クレジットカード"
            : "コンビニ"
        ),
        departureName: encodeURIComponent(
          this.finishData.data.reservation_list[0].station_list[0]
            .station_name_full
        ),
        destinationName: encodeURIComponent(
          this.finishData.data.reservation_list[0].station_list[1]
            .station_name_full
        ),
        job: "",
        customerCity: encodeURIComponent(reservationPostData.c_coty_name),
        quantity: passenger.total,
        platform: this.commonService.isMobile() ? "SP" : "PC",
        memo: encodeURIComponent(cartData[0].plan.company_name),
      };

      this.embedCodeService.googleTagReservationFinishHeaderSet(trackingInfo);
      this.embedCodeService.yahooTagReservationFinishHeaderSet(trackingInfo);
      let affCode = "";

      /* AFFILIATE CODE */
      let acdCode = this.affiliateService.getAcdCode();
      if (acdCode) {
        acdCode = acdCode.code.toLowerCase();
        switch (acdCode) {
          case "lcl":
            affCode =
              this.embedCodeService.lclTagReservationFinishHeaderSet(
                trackingInfo
              );
            break;

          case "fan":
            affCode = this.embedCodeService.a8TagReservationFinishHeaderSet(
              this.finishData.data
            );
            break;

          case "afb":
            affCode = this.embedCodeService.afbTagReservationFinishHeaderSet(
              this.finishData.data,
              cartData
            );
            this.$("#embedAffiliateCode").empty();
            break;

          case "ari":
            affCode = this.embedCodeService.ariTagReservationFinishHeaderSet(
              this.finishData.data,
              cartData
            );
            this.$("#embedAffiliateCode").empty();
            break;
        }
      }

      this.embedCodeHeader = `${affCode}`;

      /* EXECUTE JS */
      this.$("#finishEmbedCodeHeader").empty().html(this.embedCodeHeader);
    } catch (err) {
      console.log(err);
      /* DO NOTHING */
    }
  }

  /* サーバ埋め込みの予約成立データ(#acceptServerData)を読む。
     取得できない・別伝票のデータ(s_id不一致)・予約番号なしの場合はnull */
  getServerFallbackData(session_id: any) {
    try {
      /* s_idなしの遷移(SPA内遷移等)では使わない=従来挙動を維持。
         フォールバックは3DS戻り(accept?s_id=)のページロード時専用 */
      if (!session_id) {
        return null;
      }
      const el = document.getElementById("acceptServerData");
      if (!el) {
        return null;
      }
      const data = JSON.parse(el.textContent || "");
      if (!data || !data.ids || !data.ids.length) {
        return null;
      }
      if (session_id && data.sid && Number(session_id) !== Number(data.sid)) {
        return null;
      }
      return data;
    } catch (e) {
      return null;
    }
  }

  initSearchReturn() {
    const currentFilter = this.planService.getFilterOptions();
    const newFilter = {
      ...currentFilter,
      isReturn: true,
    };
    this.planService.saveFilterOptions(newFilter);

    this.commonService.redirectToRoute(
      this.commonService.routePaths.pagePlanListNoParam
    );
  }

  setGoogleGTM() {
    return `
              window.dataLayer = window.dataLayer || [];
              dataLayer.push({
                value: "${this.finishData.data.total_price}",
              });
        `;
  }
}
